<template>
  <saffron class="app-external-wrapper" :use-meta="true" :show-site-credits="false"> </saffron>
</template>

<script>
import SaffronComponent from "@/client/components/Saffron.vue";
import addWindowScript from "@/client/extensions/composition/addWindowScript";

export default {
  components: {
    Saffron: SaffronComponent,
  },
  props: {
    layout: {
      type: String,
      default: "default",
    },
    forcedLayout: {
      default: false,
      validator: (value) => typeof value === "string" || value === false,
    },
  },
  setup(props) {
    const { addScript } = addWindowScript(props);

    return {
      addScript,
    };
  },
  data() {
    return {
      isSSR: utilities.isSSR(),
    };
  },
  mounted() {

    if (utilities.isSSR()) {
      return;
    }

    if (!utilities.isSSR() && (config.isProduction || config.isStage)) {
      this.getAsset("scripts/nagish.js");
    }
  },
};
</script>

<style lang="scss" scoped>
.global-app-wrapper {
  display: flex;
  flex-direction: column;
  flex: 100vh;
  min-height: 100vh;
}


</style>

<style lang="scss">
// accessibility
body #INDWrap {
  z-index: 1!important; // will not float over any modal/notification/drawer etc
}
body #INDmenu-btn {
  top: auto !important;
  bottom: 60px !important;
}

body #INDmenu-btn svg {
  width: 60px !important;
  height: 55px !important;
  border: none!important;
  outline: 0!important;
  margin-inline-start: 30px!important;
}

body .INDlangdirRTL.INDhasDragTooltip #INDWrap #INDmenu-btn::after {
  width: 93px;
  bottom: -38px;
  height: 122px;
}
</style>
